import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["for"]

import { computed, ref } from 'vue'
import { BfFlex } from '@finetic/bikefitting-ui'
import { CommonFilterIcons } from '@/types/filter'
import { v4 as uuidv4 } from 'uuid'


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterCheckbox',
  props: /*@__PURE__*/_mergeModels({
    label: {},
    icons: {}
  }, {
    "modelValue": { type: Boolean },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const model = _useModel(__props, "modelValue")

const props = __props

const uuid = ref(uuidv4())

const iconDefault = computed(() => props.icons?.default ?? '')
const iconSelected = computed(() => props.icons?.selected ?? '')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BfFlex), {
    class: "filter-checkbox",
    align: "center"
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("input", {
        id: uuid.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
        style: _normalizeStyle(
        iconDefault.value && {
          'background-image': `url(${model.value ? iconSelected.value : iconDefault.value})`,
        }
      ),
        type: "checkbox"
      }, null, 12, _hoisted_1), [
        [_vModelCheckbox, model.value]
      ]),
      _createElementVNode("label", { for: uuid.value }, _toDisplayString(__props.label), 9, _hoisted_2)
    ]),
    _: 1
  }))
}
}

})